'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/side-channel-weakmap/~/function-bind/index.js
// module id = 2371
// module chunks = 67